<i2g-dialog-base
  [title]="titleKey | translate"
  [body]="bodyKey | translate"
  [primaryButtonText]="'ACTION.ADD_JOB' | translate"
  [secondaryButtonText]="'ACTION.NOT_NOW' | translate"
  (primaryButtonClicked)="onPrimaryButtonClicked()"
  (secondaryButtonClicked)="onSecondaryButtonClicked()"
>
</i2g-dialog-base>
